import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Button } from 'components/core';
import { builderAnswersState, builderIssuesState, rolesState, visualisationRolesState } from 'states';
import { Issue, TabId } from 'helpers/kpiBuilder/types';
import { OUTLINE_SMALL } from './buttonProps';

interface BuilderIssuesProps {
  tab: TabId;
}

// Amber banners for the current tab, each with a one-click fix when the engine offers one.
export const BuilderIssues = ({ tab }: BuilderIssuesProps) => {
  const issues = useRecoilValue(builderIssuesState).filter((i) => i.tab === tab);
  const allRoles = useRecoilValue(rolesState);
  const setAnswers = useSetRecoilState(builderAnswersState);
  const setRoles = useSetRecoilState(visualisationRolesState);

  const applyFix = (issue: Issue) => () => {
    const { answers, roles } = issue.fix ?? {};
    if (answers) setAnswers((a) => ({ ...a, ...answers }));
    if (roles) setRoles(allRoles.filter((r) => roles.includes(r.code ?? '')));
  };

  return (
    <>
      {issues.map((i) => (
        <div key={i.title} className="alert alert-warning d-flex justify-content-between align-items-center mt-3 mb-0" role="status">
          <span>
            <strong>{i.title}</strong> {i.msg}
          </span>
          {i.fix && (
            <Button {...OUTLINE_SMALL} onClick={applyFix(i)}>
              {i.fix.label}
            </Button>
          )}
        </div>
      ))}
    </>
  );
};
